import { SubmitButton } from "@circle-react/components/QuickPostV3/Composer/SubmitButton";
import { useRequestClose } from "@circle-react/components/QuickPostV3/contexts/requestCloseContext";
import { useComposerSpace } from "@circle-react/components/QuickPostV3/hooks/useComposerSpace";
import { useQuickPostV3ModalStore } from "@circle-react/components/QuickPostV3/store";
import { IconButton } from "@circleco/compass/components/IconButton";

import { t } from "@/i18n-js/instance";

export const FloatingActions = () => {
  const onRequestClose = useRequestClose();
  const goToSettings = useQuickPostV3ModalStore(state => state.goToSettings);
  const { canManageSelectedSpace } = useComposerSpace();

  return (
    <>
      <div className="absolute left-4 top-4 z-20">
        <IconButton
          variant="outline"
          size="md"
          icon="cross"
          aria-label={t("quick_post.scheduled_post_ui.cancel")}
          onClick={onRequestClose}
        />
      </div>
      <div className="absolute right-4 top-4 z-20 flex items-center gap-2">
        {canManageSelectedSpace && (
          <IconButton
            variant="outline"
            size="md"
            icon="settings-gear"
            aria-label={t("quick_post_v2.header.settings")}
            onClick={goToSettings}
          />
        )}
        <SubmitButton menuSide="bottom" />
      </div>
    </>
  );
};
